const Operation = Object.freeze({
  READ: Symbol('READ'),
  CREATE: Symbol('CREATE'),
  UPDATE: Symbol('UPDATE'),
  DELETE: Symbol('DELETE'),
});

export function isValidOperation(op) {
  return (
    Object.keys(Operation)
      .map(opName => Operation[opName])
      .indexOf(op) > -1
  );
}

export function getOperationName(op) {
  return String(op).replace(/Symbol\(|\)/gi, '');
}

export default Operation;
